<div class="app-modal-spinner">

  <header class="edit-header">
    <h1>{{titleName}}</h1>
  </header>
  <div class="container">
    <!-- info -->
    <div class="content-container">
      <p class="header">帳票名</p>
      <p class="content">
        <span>{{record?.ttlnm}}</span>
      </p>
    </div>
    <div class="content-container">
      <p class="header">対象者</p>
      <p class="content">
        <span>{{daiName}}</span>
      </p>
    </div>
    <div class="content-container">
      <p class="header">記録者</p>
      <p class="content">
        <span>{{ordName}}</span>
      </p>
    </div>
    <div class="content-container">
      <p class="header">ユニット</p>
      <p class="content">
        <span>{{unitName}}</span>
      </p>
    </div>
    <hr />
    <!-- datetime -->
    <div class="checkbox-field">
      <mat-checkbox [formControl]="handover" disableRipple>申し送り</mat-checkbox>
      <mat-checkbox [formControl]="summary" disableRipple>サマリー</mat-checkbox>
    </div>
    <app-datetime-field label="開始日時" [form]="startDate" (formChange)="[startDateChange(),compareDate(), onChange()]"></app-datetime-field>
    <app-select-item [label]="'期間'" [placeholder]="''" [selectStyle]="{width: 'calc(50% - 8px)'}"
      [options]="durationOptions" (onChange)="changeEndDate($event)"  [currentValue]="currentOption"></app-select-item>
    <app-datetime-field label="終了日時" [form]="endDate" (formChange)="[compareDate(), onChange()]" [disabled]="!isDecide">
      <mat-error *ngIf="endDate.hasError('compareDate')">終了日時は開始日時より後の日時を入力してください</mat-error>
    </app-datetime-field>
    <div class="checkbox-field">
      <mat-checkbox disableRipple (change)="changeDecide($event)" [checked]="!isDecide">未定</mat-checkbox>
    </div>
    <!-- comment -->
    <div class="form-field">
      <span class="form-field-label">
        コメント
      </span>
      <textarea matInput (input)="onSubjectChange($event)" [value]="subject?.value"></textarea>
    </div>
  </div>
  <!-- footer -->
  <footer class="edit-footer">
    <button type="button" mat-button class="cancel" (click)="cancel()">
      キャンセル
    </button>
    <button mat-button class="excute" (click)="next()" [disabled]="isDecide && !isValid">
      確定
    </button>
  </footer>
</div>